import React from 'react'

import { UserProfile } from './common/UserProfile/UserProfile'

import styles from './TopBar.module.scss'

export const TopBar = ({ children }) => (
  <header className={styles.bar}>{children}</header>
)

TopBar.UserProfile = UserProfile
